var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState } from "react";
import { getStoredValue, useLocalStorage } from "./useLocalStorage";
export var DEFAULT_DETAIL_KEY = "default";
var ValueType;
(function (ValueType) {
    ValueType["Ordering"] = "ordering";
    ValueType["Filters"] = "filters";
    ValueType["Columns"] = "columns";
})(ValueType || (ValueType = {}));
export function useArticleTableConfig(key) {
    var storeKey = "ArticleTableConfig::".concat(key);
    var _a = useLocalStorage(storeKey), storedConfig = _a[0], setStoredValues = _a[1];
    var _b = useState(storedConfig), config = _b[0], setConfig = _b[1];
    var configDoesNotExist = function (updatableConfig, configKey) {
        return updatableConfig.filter(function (element) { var _a; return ((_a = element.details) === null || _a === void 0 ? void 0 : _a.key) === configKey; })
            .length === 0;
    };
    var setValues = function (configKey, values, typeOf) {
        var updatableConfig = storedConfig !== null && storedConfig !== void 0 ? storedConfig : [];
        if (updatableConfig.length > 0) {
            updatableConfig === null || updatableConfig === void 0 ? void 0 : updatableConfig.forEach(function (element, index) {
                var _a;
                var _b;
                if (((_b = element.details) === null || _b === void 0 ? void 0 : _b.key) === configKey) {
                    updatableConfig[index] = __assign(__assign({}, element), (_a = {}, _a[typeOf] = values, _a));
                }
            });
            if (configDoesNotExist(updatableConfig, configKey)) {
                pushInitialSetup(updatableConfig, configKey, typeOf, values);
            }
        }
        else {
            pushInitialSetup(updatableConfig, configKey !== null && configKey !== void 0 ? configKey : DEFAULT_DETAIL_KEY, typeOf, values);
        }
        setStoredValues(updatableConfig);
    };
    var setFilters = function (filters, configKey) {
        return setValues(configKey !== null && configKey !== void 0 ? configKey : DEFAULT_DETAIL_KEY, filters, ValueType.Filters);
    };
    var setOrdering = function (ordering, configKey) {
        return setValues(configKey !== null && configKey !== void 0 ? configKey : DEFAULT_DETAIL_KEY, ordering, ValueType.Ordering);
    };
    var setColumns = function (columns, configKey) {
        return setValues(configKey !== null && configKey !== void 0 ? configKey : DEFAULT_DETAIL_KEY, columns, ValueType.Columns);
    };
    var setDetails = function (details) {
        return setStoredValues([__assign(__assign({}, storedConfig), { details: details })]);
    };
    var getConfig = function (configKey) {
        return storedConfig.length > 0
            ? storedConfig.filter(function (element) { var _a; return ((_a = element.details) === null || _a === void 0 ? void 0 : _a.key) === configKey; })[0]
            : undefined;
    };
    var refetch = function () {
        var item = getStoredValue(storeKey, storedConfig);
        setConfig(item);
    };
    return {
        config: config,
        getConfig: getConfig,
        setFilters: setFilters,
        setOrdering: setOrdering,
        setColumns: setColumns,
        refetch: refetch,
        setDetails: setDetails,
    };
}
var pushInitialSetup = function (updatableConfig, key, typeOf, values) {
    var _a;
    return updatableConfig.push((_a = {
            details: {
                key: key,
            }
        },
        _a[typeOf] = values !== null && values !== void 0 ? values : undefined,
        _a));
};
export var filterByDetail = function (config, configKey) {
    return config.filter(function (element) { var _a; return ((_a = element.details) === null || _a === void 0 ? void 0 : _a.key) === (configKey !== null && configKey !== void 0 ? configKey : DEFAULT_DETAIL_KEY); })[0];
};
